<template>
  <section id="checkout" class="checkout-section">
    <div class="container">
      <div class="checkout-content">
        <div class="row">
          <div class="col-md-9">

            <div class="box" v-for="item in certs" :key="item.CertId">
              <span>{{item.CertFirstName}}{{item.CertLastName}}</span>
              <div class="content">
                <div class="content-left">
                  <div>
                    <span>姓名：</span><span>{{item.EmployeeName}}</span>
                  </div>
                  <div>
                    <span>性别：</span><span>{{item.Sex==1?"女":"男"}}</span>
                  </div>
                  <div>
                    <span>身份证号：</span><span>{{item.EmployeeIdNumber}}</span>
                  </div>
                  <div>
                    <span>单位名称：</span><span>{{item.EnterpriseName}}</span>
                  </div>
                  <div>
                    <span>证书名称：</span><span>{{item.CertFirstName}}</span>
                  </div>
                  <div>
                    <span>岗位名称：</span><span>{{item.JobName}}</span>
                  </div>
                  <div>
                    <span>发证时间：</span><span>{{item.CertDate}}</span>
                  </div>
                </div>
                <div class="content-right">
                  <div class="pic">
                    <img :src="item.Photo" />
                  </div>
                  <div v-for="(review, index) in item.ReviewDates" :key="index">
                    <span>第{{index+1}}次延期：</span><span>{{review}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-md-3">
            <component :is="newsView" ref="newsView"></component>
            <div v-if="qrCodeURL" class="side-bar-widget">
              <h2 class="widget-title text-capitalize"><span>微信</span> {{isMiniQrCode ? '小程序' : '公众号'}}</h2>
              <div class="featured-course">
                <div class="best-course-pic-text relative-position">
                  <div class="best-course-pic relative-position">
                    <img :src="qrCodeURL" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Vue, mapGetters, ProjectSettings } from '../base/base.js';
export default {
  data() {
    return {
      qrCodeURL: ProjectSettings.WeiXinURL,
      isMiniQrCode: ProjectSettings.IsMiniQrCode
    }
  },
  computed: {
    ...mapGetters({
      certs: 'getSearchCerts'
    })
  },
  created: function () {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/list'], resolve)
    });
  },
  methods: {
    onSubmit() {
      this.$router.push({ name: 'certificate' })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  > span {
    font-size: 30px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #333333;
  }
  > .content {
    display: flex;
    font-size: 16px;
    color: #777777;
    margin-top: 48px;
    border-bottom: solid 1px #cccccc;
    .content-left {
      flex: 1;
      > div {
        margin-bottom: 20px;
        display: flex;
        > span {
          width: 100px;
          text-align: right;
          & + span {
            text-align: left;
            flex: 1;
          }
        }
      }
    }
    .content-right {
      flex: 1;
      .pic {
        display: flex;
        height: 150px;
        img {
          width: 96px;
          height: 144px;
          margin-left: 80px;
        }
      }

      > div {
        margin-bottom: 20px;
        display: flex;
        > span {
          width: 100px;
          text-align: right;
          & + span {
            text-align: left;
            flex: 1;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/diploma_info.vue